import { render, staticRenderFns } from "./AreYouSureToDeleteCard.vue?vue&type=template&id=f8b97128&scoped=true&"
import script from "./AreYouSureToDeleteCard.vue?vue&type=script&lang=js&"
export * from "./AreYouSureToDeleteCard.vue?vue&type=script&lang=js&"
import style0 from "./AreYouSureToDeleteCard.vue?vue&type=style&index=0&id=f8b97128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b97128",
  null
  
)

export default component.exports